import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

/**
 * Small wrapper that shows a dark Etherscan-style tooltip immediately on hover.
 * Usage:
 *   <HoverTip label="Out of gas"><Icon/></HoverTip>
 */
export default function HoverTip({ label, children, side = "top" }) {
  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">{children}</span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="bg-slate-900 text-white border border-slate-700 shadow-lg max-w-xs text-[11px] leading-snug"
        >
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
